import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type SegmentBox } from 'entities/Segment'
import {
  type EnumEnrollmentMode,
  type IApplyChangeModal,
} from 'widgets/ContactEnrollment/store/types'
import { type FilterEditorStore } from 'widgets/FilterEditor'
import { type EnrollmentListStore } from 'widgets/ContactEnrollment/store'
import { EnrollmentFilterTab } from '../EnrollmentFilterTab/EnrollmentFilterTab'

type IEnrollmentExcludeProps = {
  enrollmentListStore: EnrollmentListStore
  excludeFilterEditorStore: FilterEditorStore
  excludeSegmentBox: SegmentBox
  mode: EnumEnrollmentMode
  showList?: boolean
  applyExcludeChangeModal: IApplyChangeModal
}

export const EnrollmentExclude: FC<IEnrollmentExcludeProps> = observer(
  ({
    enrollmentListStore,
    excludeFilterEditorStore,
    excludeSegmentBox,
    mode,
    showList,
    applyExcludeChangeModal,
  }) => (
    <EnrollmentFilterTab
      items={enrollmentListStore.allExcludeFiltersWithCount}
      preview={enrollmentListStore.excludePreview}
      addOrUpdateItem={enrollmentListStore.addOrUpdateExcludeItem}
      searchDropdownStore={enrollmentListStore.excludeSearchDropdownStore}
      filterEditorStore={excludeFilterEditorStore}
      segmentBox={excludeSegmentBox}
      mode={mode}
      showList={showList}
      applyChangeModal={applyExcludeChangeModal}
    />
  )
)
